import Cookies from 'js-cookie';
import forceLogoutHandler from './a.users.forceLogoutHandler';

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// GET NOTIFICIATIONS
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetUserNotifications = packet => {
  return {
    type: 'REQUEST_GET_USER_NOTIFICATIONS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetUserNotificationsSuccess = data => ({
  type: 'RECEIVE_GET_USER_NOTIFICATIONS_SUCCESS',
  data
})

export const receiveGetUserNotificationsFail = data => ({
  type: 'RECEIVE_GET_USER_NOTIFICATIONS_FAIL',
  data
})

export const tryToGetUserNotifications = packet => (dispatch, getState) => {

  dispatch(requestGetUserNotifications(packet));


  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/users/notifications?' + new URLSearchParams(packet), {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetUserNotificationsSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetUserNotificationsFail({errors:e, lastSubmit: packet}));
    })
}
